import { render, staticRenderFns } from "./FundingReport.vue?vue&type=template&id=ffa591ba&scoped=true"
import script from "./FundingReport.vue?vue&type=script&lang=js"
export * from "./FundingReport.vue?vue&type=script&lang=js"
import style0 from "./FundingReport.vue?vue&type=style&index=0&id=ffa591ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa591ba",
  null
  
)

export default component.exports